import _, { property } from 'lodash';
/**
 * @param {{ answers: { display_order: number }[] }} section
 * @returns {number[]}
 */
export const deriveDisplayOrder = items =>
    _(items)
        .flatMap((item, index) => (
            item?.answers.map((a, i) => ({
                index,
                answerIndex: i,
                dropZoneLocation: a.is_correct_answer ? item.drop_zone_location : null,
                displayOrder: a.display_order,
                isDistractor: !a.is_correct_answer
            }))))
        .sortBy(property('displayOrder'))
        .value()




// Basic 2D bounding box check
export const isWithin = (bounding_box, { x, y }) =>
    bounding_box.left <= x && x <= bounding_box.right
    && bounding_box.top <= y && y <= bounding_box.bottom;
